/**
 * @file 导出函数统一出口
 */

import * as componentStoreFunctionImpl from './componentStoreFunctionImpl';
import * as expressionFunctionImpl from './expressionFunctionImpl';
import * as loopFunctionImpl from './loopFunctionImpl';
import * as timerFunctionImpl from './timerFunctionImpl';
import * as lodashFunctionImpl from './lodashFunctionImpl';
import * as snowflakeFunctionImpl from './snowflakeFunctionImpl';
import * as windowFunctionImpl from './windowFunctionImpl';
import * as requestFunctionImpl from './requestFunctionImpl';
import * as maxFunctionImpl from './maxFunctionImpl';
import * as getRowDataImpl from './getRowDataImpl';
import * as invokeCustomFunctionImpl from './invokeCustomFunctionImpl';
import * as formFunctionImpl from './formFunctionImpl';
import * as dataSourceFunctionImpl from './dataSourceFunctionImpl';
import * as routeFunctionImpl from './routeFunctionImpl';
let modules = [maxFunctionImpl, getRowDataImpl, componentStoreFunctionImpl, expressionFunctionImpl, loopFunctionImpl, timerFunctionImpl, lodashFunctionImpl, snowflakeFunctionImpl, windowFunctionImpl, invokeCustomFunctionImpl, requestFunctionImpl, formFunctionImpl, dataSourceFunctionImpl, routeFunctionImpl];

const functionImpl = {};

// 读取目录中的所有文件
modules.forEach(moduleExports => {
  // 将导出的方法添加到 functionImpl 对象中
  for (const key in moduleExports) {
    functionImpl[key] = moduleExports[key];
  }
});

export default functionImpl;
